import { deepEquals } from 'app/infrastructure/js';
import { userMembersAction } from '../constants';
import { ListAction, ListBranch, ListBranchItem } from '../types-store';
import { mapInitialSelection, mapActionsToSelection } from './map-selection';

export const hasChanges = (
  listBranch: ListBranch[],
  listActions: ListAction[],
  initialValueSelected: (item: ListBranchItem) => boolean
) => {

  if (!listActions?.length || !listBranch?.length) {
    return false;
  }

  if (listActions.some(action => action.type === userMembersAction.selectAll
    || action.type === userMembersAction.deselectAll)) {
    return true;
  }

  const initialSelection = mapInitialSelection(listBranch, initialValueSelected);

  const selectionAfterActions = mapActionsToSelection(initialSelection, listActions);

  if (!deepEquals(initialSelection, selectionAfterActions)) {
    return true;
  }

  return false;

};
